import { apiFetch, tokenStore } from './client';

/**
 * Storefront API surface. Every call maps to a backend route. Components should
 * import from here rather than calling apiFetch directly.
 */
export const api = {
  tokenStore,

  // ── Store config ──────────────────────────────────────
  getSettings: () => apiFetch('/settings'),

  // ── Catalogue ─────────────────────────────────────────
  getProducts: (query = '') => apiFetch(`/products${query ? `?${query}` : ''}`),
  getProduct: (id) => apiFetch(`/products/${id}`),
  getCategories: () => apiFetch('/products/categories'),

  // ── Auth (customer) ───────────────────────────────────
  register: (payload) => apiFetch('/auth/register', { method: 'POST', body: payload }),
  login: (payload) => apiFetch('/auth/login', { method: 'POST', body: payload }),
  me: () => apiFetch('/auth/me', { auth: true }),
  updateProfile: (payload) => apiFetch('/auth/me', { method: 'PATCH', body: payload, auth: true }),

  // ── Addresses ─────────────────────────────────────────
  getAddresses: () => apiFetch('/auth/addresses', { auth: true }),
  addAddress: (payload) => apiFetch('/auth/addresses', { method: 'POST', body: payload, auth: true }),
  deleteAddress: (id) => apiFetch(`/auth/addresses/${id}`, { method: 'DELETE', auth: true }),

  // ── Orders ────────────────────────────────────────────
  createOrder: (payload) =>
    apiFetch('/orders', { method: 'POST', body: payload, auth: !!tokenStore.get() }),
  getMyOrders: () => apiFetch('/orders/mine', { auth: true }),
  getOrder: (id, email) =>
    apiFetch(`/orders/${id}${email ? `?email=${encodeURIComponent(email)}` : ''}`, {
      auth: !!tokenStore.get(),
    }),

  // ── Payments ──────────────────────────────────────────
  createStripeSession: (orderId) =>
    apiFetch('/payments/stripe/session', { method: 'POST', body: { orderId } }),

  // ── Marketing ─────────────────────────────────────────
  subscribeNewsletter: (email) => apiFetch('/newsletter', { method: 'POST', body: { email } }),
  sendContact: (payload) => apiFetch('/contact', { method: 'POST', body: payload }),
};
